import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import { Grid } from '@material-ui/core';

const styles = (theme) => ({
  root: {},
  iconCheck: {
    color: theme.palette.facet.accentGreen,
    fontSize: theme.typography.h5.fontSize,
    margin: theme.spacing(0.3, 0.5, 0, 0),
  },
});

const AuthenticationFactorListItemAction = ({
  className,
  classes,
  authenticationFactorResource,
}) => {
  return authenticationFactorResource.attr('enabled') === 'true' ? (
    <Grid className={classNames(classes.root, className)} container>
      <FontAwesome className={classes.iconCheck} icon="check-circle" test={`security-settings-icon-authentication-factor-${authenticationFactorResource.attr('authenticationType')}-enabled`} />
      <BodyText text={'Enabled'} />
    </Grid>
  ) : null;
};

AuthenticationFactorListItemAction.defaultProps = {
  className: '',
};

AuthenticationFactorListItemAction.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  authenticationFactorResource: PropTypes.object.isRequired,

};

export default withStyles(styles)(AuthenticationFactorListItemAction);
